export const bizGubn = [
    { code: '', name: '선택' },
    { code: '001', name: '골프장' },
]
